// Function to clean up blue highlights and normalize mark tags
export const cleanupBlueHighlights = (html) => {
  if (!html) return html;
  let cleaned = html.replace(/<mark[^>]*style="[^"]*background-color:\s*(blue|#[0-9a-fA-F]{3,6}|rgb\([^)]+\))[^"]*"[^>]*>/gi, '<mark>');
  cleaned = cleaned.replace(/<mark[^>]*data-color="[^"]*"[^>]*>/gi, '<mark>');
  return cleaned;
};

// Function to auto-link URLs and emails in text
export const autoLinkContent = (html) => {
  if (!html) return html;
  const urlRegex = /(?<!href=["']?)(?<!>)(https?:\/\/[^\s<>"]+)/gi;
  const emailRegex = /(?<!href=["']mailto:)(?<!>)([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;
  let result = html;
  result = result.replace(urlRegex, (match) => {
    return `<a href="${match}" target="_blank" rel="noopener noreferrer">${match}</a>`;
  });
  result = result.replace(emailRegex, (match) => {
    return `<a href="mailto:${match}">${match}</a>`;
  });
  return result;
};
